module.exports = __webpack_public_path__ + "/img/6db0872a8f8b69dd4521995b5a4b4d56.svg";